import request from '@/utils/request'

// 查询图库列表
export function listImgMap(params) {
  return request({
    url: '/server/map/list',
    method: 'get',
    params: params
  })
}
// 导出图库列表
export function exportImgMap(data) {
  return request({
    url: '/server/map/export',
    method: 'get',
    data: data
  })
}
// 获取图库详细信息
export function getImgMap(data) {
  return request({
    url: '/server/map/getInfo/'+data.mapId,
    method: 'get',
    data: data
  })
}
// 新增图库 
export function addImgMap(data) {
  return request({
    url: '/server/map/add',
    method: 'post',
    data: data
  })
}
// 修改图库 含删除图库
export function editImgMap(data) {
  return request({
    url: '/server/map/edit',
    method: 'post',
    data: data
  })
}
// 彻底删除图库
export function deleteImgMap(data) {
  return request({
    url: '/server/map/delete/'+data.mapId,
    method: 'post',
    data: data
  })
}

// 查询图库分类列表
export function listImgMapType(data) {
  return request({
    url: '/server/map/type/list',
    method: 'get',
    data: data
  })
} 
// 获取图库分类树
export function getImgMapTypeTree(data) {
  return request({
    url: '/server/map/type/tree',
    method: 'get',
    params: data
  })
}
// 获取图库分类树
export function getImgMapTypeSelect(data) {
  return request({
    url: '/server/map/type/select',
    method: 'get',
    params: data
  })
}
// 新增图库分类
export function addImgMapType(data) {
  return request({
    url: '/server/map/type/add',
    method: 'post',
    data: data
  })
}
// 修改图库分类
export function editImgMapType(data) {
  return request({
    url: '/server/map/type/edit',
    method: 'post',
    data: data
  })
}
// 删除图库分类
export function deleteImgMapType(data) {
  return request({
    url: '/server/map/type/delete/'+data.typeId,
    method: 'post',
    data: data
  })
}

// 查询共享图库列表
export function listShare(data) {
  return request({
    url: '/server/map/listShare',
    method: 'GET',
    params: data
  })
}

// 查询出单图库列表
export function listOrder(data) {
  return request({
    url: '/server/map/listOrder',
    method: 'GET',
    params: data
  })
}

// 新增图库分享
export function addShare(data) {
  return request({
    url: '/server/map/addShare',
    method: 'post',
    data: data
  })
}
// 获取共享图库分类树
export function getShareTree(data) {
  return request({
    url: '/server/map/type/share/tree',
    method: 'GET',
    data: data
  })
}
// 查询图库出单订单列表
export function listMap(data) {
  return request({
    url: '/server/order/listMap',
    method: 'GET',
    params: data
  })
}
// 查询图库出单订单列表
export function listDesign(data) {
  return request({
    url: '/server/map/listDesign',
    method: 'GET',
    params: data
  })
}

// 查询子账号图库列表
export function listChild(data) {
  return request({
    url: '/server/map/listChild',
    method: 'GET',
    params: data
  })
}
// 查询图库出单订单列表
export function listChildTree(data) {
  return request({
    url: '/server/map/type/child/tree',
    method: 'GET',
    params: data
  })
}
// 查询图库出单订单列表
export function updateName(data) {
  return request({
    url: '/server/map/updateName',
    method: 'POST',
    data: data
  })
}
